import { useState } from "react";
import { useDispatch, useSelector } from "react-redux"; // Aggiunto useSelector
import {
  Arrow,
  MainLayoutWrapper,
  RightWrapper,
  SideBarWrapper,
  WrapperOutlet,
} from "./style";

//components
import Header from "./header/Header";
import LinksSideBar from "./sideBar/LinksSideBar";
import InternalSideBar from "./sideBar/InternalSideBar";
import { useLogoutUserMutation } from "../../redux/features/auth/authApi";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../utils/hooks/useAuth";
import { useGetUserByUserIdQuery } from "../../redux/features/usersManagement/usersManagementApi";
import { commonRoutes } from "../../utils/routes/Routes";
import SidebarDrawer from "../common/SidebarDrawer";
import {
  getDecriptedTokenInfo,
  getLoginData,
} from "../../redux/features/auth/authSlice";

export default function DashboardMainLayout() {
  const [openSideBar, setOpenSideBar] = useState(false);
  const [logoutUser, { data, isError, isSuccess }] = useLogoutUserMutation();
  const dispatch = useDispatch();
  const { auth } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async (e) => {
    e.preventDefault();
    const updatedToken = await logoutUser(auth?.token);
    dispatch(
      getLoginData({
        ...auth,
        token: updatedToken.data,
        userData: null,
      })
    );
    dispatch(
      getDecriptedTokenInfo({ ...auth.decriptedTokenInfo, expired: true })
    );

    if (!isError) {
      navigate(commonRoutes.login);
    }
  };

  const onOpenDrawer = (value) => {
    setOpenSideBar(value);
  };

  const {
    data: userProfileData,
    isError: userProfileError,
    isLoading: userProfileLoading,
  } = useGetUserByUserIdQuery(auth?.userData?.id, {
    skip: !auth?.userData?.id,
  });

  return (
    <MainLayoutWrapper>
      <SideBarWrapper>
        <LinksSideBar
          userProfileData={userProfileData}
          open={openSideBar}
          handleLogout={handleLogout}
        />
        <SidebarDrawer
          open={openSideBar}
          setOpen={setOpenSideBar}
          anchor="right"
        >
          <InternalSideBar
            userProfileData={userProfileData}
            onOpenDrawer={onOpenDrawer}
          />
        </SidebarDrawer>
      </SideBarWrapper>
      <RightWrapper>
        <Header onOpenDrawer={onOpenDrawer} />
        <WrapperOutlet>
          <Outlet />
        </WrapperOutlet>
      </RightWrapper>
    </MainLayoutWrapper>
  );
}
